export default __webpack_public_path__ + "static/media/not-found-btn.b8587f6b.svg";